module.exports = __webpack_public_path__ + "static/img/reservation.97641ac7.svg";